import React from "react";
import { trackButtonClick } from "../../../services/googleSheetsService";

import share_print from "../../../assets/images/printer.png";
import share_map from "../../../assets/images/icons8-map-64.png";
import share_video from "../../../assets/images/icons8-cinema-40.png";

/**
 * 配速計時器功能按鈕組元件
 * @param {Object} props
 * @param {Function} props.onDownload - 下載配速手環的處理函式
 * @param {Function} props.onShowMap - 顯示賽道地圖的處理函式
 * @param {Function} props.onShowVideo - 顯示賽道影片的處理函式（可選）
 * @param {string} props.mapTrackingEvent - 地圖追蹤事件名稱
 * @param {string} props.videoTrackingEvent - 影片追蹤事件名稱
 * @param {boolean} props.showVideoButton - 是否顯示影片按鈕（預設：true）
 */
function PaceTimerButtons({
    onDownload,
    onShowMap,
    onShowVideo,
    mapTrackingEvent = "賽道地圖",
    videoTrackingEvent = "賽道影片",
    showVideoButton = true,
}) {
    return (
        <div className="print-btn-wrap">
            {onDownload && (
                <div className="print-btn" onClick={onDownload}>
                    <img src={share_print} alt="下載配速手環icon" />
                    <div>下載配速手環</div>
                </div>
            )}
            {onShowMap && (
                <div
                    className="print-btn"
                    onClick={() => {
                        if (mapTrackingEvent) {
                            trackButtonClick(mapTrackingEvent, "Map");
                        }
                        onShowMap();
                    }}
                >
                    <img src={share_map} alt="賽道地圖" />
                    <div>賽道地圖</div>
                </div>
            )}
            {showVideoButton && onShowVideo && (
                <div
                    className="print-btn"
                    onClick={() => {
                        if (videoTrackingEvent) {
                            trackButtonClick(videoTrackingEvent, "Video");
                        }
                        onShowVideo();
                    }}
                >
                    <img src={share_video} alt="賽道影片" />
                    <div>賽道影片</div>
                </div>
            )}
        </div>
    );
}

export default PaceTimerButtons;
